<!-- -->
<template>
  <viewer :images="images">
    <img class="mr20" v-for="src in images"
              :style="{
                width: `${width}px`,
                height:`${height}px`
              }"
              :src="src" :key="src" />
  </viewer>
</template>

<script>
  export default {
    props:{
      width:{
        type:Number,
        default:100
      },
      height:{
        type:Number,
        default:100
      },
      images:{
        type:Array,
        default:[],
      }
    },
    name: "image-show",
    data() {
      return {}
    },
    mixins: [tableBase],
    methods: {},
    mounted() {
    }
  }
</script>

<style lang="less" scoped>
img{
  object-fit: cover;
}
</style>
